import React from 'react';
import PropTypes from 'prop-types';

import * as TableConfigs from './TableConfigs/TableConfigs';

import * as APP_CONST from '../../../constants/appConsts';

import styles from './Items.module.css';
import tableConfigStyles from './TableConfigs/TableConfigs.module.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { Col, Image, Row } from 'react-bootstrap';
import Kinostyles from '../../Util/AutokinoStylesComponent.module.css';
import Counter from '../../UI/Counter/Counter';
import * as ROUTES from '../../../constants/routes';

export const Items = ({
  data,
  loading,
  isRemovingFromCart,
  onDeleteItem,
  incCounterClicked,
  decCounterClicked,
  onCounterChange,
  onCheckboxChange,
  disable,
}) => {
  const dataArray = Object.values(data).sort((a, b) =>
    a.order.toString() > b.order.toString() ? 1 : -1
  );
  console.log('cartItems = ' + JSON.stringify(dataArray));
  const RenderMobileRow = (item, counter) => {
    return (
      <div className={(counter % 2 > 0) ? styles.TableOdd : styles.TableEven}>
        <Row key={item.id}>
          <Col xs="6">Produkt</Col>
          <Col xs="6" className={styles.ColumnRight}>
            {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
              item.productType === APP_CONST.PRODUCT_TYPE_EVENT ||
              item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER ? (
              <div className={['show-wrapper', tableConfigStyles.InfoWrapper].join(' ')}>
                <div className={styles.ThumbnailBox}>
                  <a href={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                      ? `${ROUTES.SHOW}/${item.show.showId}`
                      : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? `${ROUTES.EVENT_ITEM}/${item.show.showId}`
                        : `${ROUTES.GIFTCARD}`
                  }
                    id={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                        item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? item.show.showId
                        : item.id
                    }
                    title={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                        ? item.movie.movieName
                        : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                          ? item.event.eventName
                          : item.product.productName
                    }
                  >
                    <Image
                      fluid={true}
                      className={styles.Thumbnail}
                      src={
                        item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                          ? item.movie.imagePath
                          : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                            ? item.event.thumbImage //row.original.event.thumbImage
                            : item.product.productImagePath
                      }
                      alt={
                        item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                          ? item.movie.imageName
                          : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                            ? item.event.eventName
                            : item.product.productName
                      }
                    />
                  </a>
                </div>
                <div className={styles.PreloadLinkWrapper}>
                  <a
                    href={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                        ? `${ROUTES.SHOW}/${item.show.showId}`
                        : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                          ? `${ROUTES.EVENT_ITEM}/${item.show.showId}`
                          : `${ROUTES.GIFTCARD}`
                    }
                    id={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                        item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? item.show.showId
                        : item.product.id
                    }
                    title={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                        ? item.movie.movieName
                        : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                          ? item.event.eventName
                          : item.product.productName
                    }
                    className={styles.Title}
                  >
                    {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ? (
                      <span>
                        {item.movie.movieName} {item.show.date}{' '}
                        {item.show.time}
                      </span>
                    ) : item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                      <span>
                        {item.event.eventName} {item.show.date}{' '}
                        {item.show.time}
                      </span>
                    ) : (
                      <span>{item.product.productName}</span>
                    )}
                  </a>
                </div>
              </div>
            ) : item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
              <div className="voucher-item-wrapper">{item.productName}</div>
            ) : (
              <div className="product-wrapper">
                {item.product.productName}
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="6">Einzelpreis</Col>
          <Col xs="6" className={styles.ColumnRight}>
            <div>
              <span>
                <b>
                  {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                    item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                    <span />
                  ) : item.productType !== APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
                    <span>&euro;{item.product.price}</span>
                  ) : (
                    <span>&euro;{item.price}</span>
                  )}
                </b>
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="6">Anzahl</Col>
          <Col xs="6" className={styles.ColumnRight}>
            <div>
              {item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ||
                (item.product != null && item.product.productOrderType === APP_CONST.PRODUCT_ORDER_TYPE_OPTION) ? (
                <div>
                  <span>
                    {item.count ? item.count : item.amount}
                  </span>
                </div>
              ) : (item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                <div />
              ) : (
                <div className={tableConfigStyles.Counter}>
                  <Counter
                    value={item.amount}
                    incClicked={e => incCounterClicked(e, item.key)}
                    decClicked={e => decCounterClicked(e, item.key)}
                    onChange={e => onCounterChange(e, item.key)}
                  />
                </div>
              )
              )
              }
            </div></Col>
        </Row>
        <Row>
          <Col xs="6">Positionssumme</Col>
          <Col xs="6" className={styles.ColumnRight}>
            <span>
              &euro;&nbsp;
              {item.totalPrice ? ((item.totalPrice)) : ''}
            </span></Col>
        </Row>
      </div>
    );
  };

  const RenderDesktopRow = (item) => {
    return (
      <Row key={item.id} className={tableConfigStyles.TableRow}>
        <Col lg="4">
          {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
            item.productType === APP_CONST.PRODUCT_TYPE_EVENT ||
            item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER ? (
            <div className={['show-wrapper', tableConfigStyles.InfoWrapper].join(' ')}>
              <div className={styles.ThumbnailBox}>
                <a href={
                  item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                    ? `${ROUTES.SHOW}/${item.show.showId}`
                    : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                      ? `${ROUTES.EVENT_ITEM}/${item.show.showId}`
                      : `${ROUTES.GIFTCARD}`
                }
                  id={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                      item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                      ? item.show.showId
                      : item.id
                  }
                  title={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                      ? item.movie.movieName
                      : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? item.event.eventName
                        : item.product.productName
                  }
                >
                  <Image
                    fluid={true}
                    className={styles.Thumbnail}
                    src={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                        ? item.movie.imagePath
                        : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                          ? item.event.thumbImage //row.original.event.thumbImage
                          : item.product.productImagePath
                    }
                    alt={
                      item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                        ? item.movie.imageName
                        : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                          ? item.event.eventName
                          : item.product.productName
                    }
                  />
                </a>
              </div>
              <div className={styles.PreloadLinkWrapper}>
                <a
                  href={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                      ? `${ROUTES.SHOW}/${item.show.showId}`
                      : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? `${ROUTES.EVENT_ITEM}/${item.show.showId}`
                        : `${ROUTES.GIFTCARD}`
                  }
                  id={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                      item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                      ? item.show.showId
                      : item.product.id
                  }
                  title={
                    item.productType === APP_CONST.PRODUCT_TYPE_SHOW
                      ? item.movie.movieName
                      : item.productType === APP_CONST.PRODUCT_TYPE_EVENT
                        ? item.event.eventName
                        : item.product.productName
                  }
                  className={styles.Title}
                >
                  {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ? (
                    <span>
                      {item.movie.movieName} {item.show.date}{' '}
                      {item.show.time}
                    </span>
                  ) : item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                    <span>
                      {item.event.eventName} {item.show.date}{' '}
                      {item.show.time}
                    </span>
                  ) : (
                    <span>{item.product.productName}</span>
                  )}
                </a>
              </div>
            </div>
          ) : item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
            <div className="voucher-item-wrapper">{item.productName}</div>
          ) : (
            <div className="product-wrapper">
              {item.product.productName}
            </div>
          )}
        </Col>
        <Col lg="4">
          <div className={tableConfigStyles.Cell}>
            <span>
              <b>
                {item.productType === APP_CONST.PRODUCT_TYPE_SHOW ||
                  item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
                  <span />
                ) : item.productType !== APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
                  <span>&euro;{item.product.price}</span>
                ) : (
                  <span>&euro;{item.price}</span>
                )}
              </b>
            </span>
          </div>
        </Col>
        <Col lg="2">
          <div className={tableConfigStyles.FlexCell}>
            {item.productType === APP_CONST.PRODUCT_TYPE_VOUCHER_ITEM ? (
              <div className={tableConfigStyles.Cell}>
                <span>
                  {item.count}
                </span>
              </div>
            ) : (item.productType === APP_CONST.PRODUCT_TYPE_EVENT ? (
              <div />
            ) : (
              <div className={tableConfigStyles.Counter}>
                <Counter
                  value={item.amount}
                  incClicked={e => incCounterClicked(e, item.key)}
                  decClicked={e => decCounterClicked(e, item.key)}
                  onChange={e => onCounterChange(e, item.key)}
                />
              </div>
            )
            )
            }
          </div></Col>
        <Col lg="2" className={styles.ColumnRight}>

          <span>
            &euro;&nbsp;
            {item.totalPrice ? ((item.totalPrice)) : ''}
          </span>

        </Col>
      </Row >
    );
  }

  const desktopListItems = dataArray ? dataArray.map(item => RenderDesktopRow(item)) : <></>;
  const mobileListItems = dataArray ? dataArray.map((item, index) => RenderMobileRow(item, index)) : <></>;


  return (
    <div className={styles.Container}>
      <div className="d-lg-none">
        <Row className={'ms-1 me-1'}>
          <Col xs={6}>
          </Col>
          <Col xs={6}>
          </Col>
        </Row>
        {mobileListItems}
      </div>
      <div className="d-none d-lg-block">
        <Row className={styles.TableHeader}>
          <Col lg={4}>
            Beschreibung
          </Col>
          <Col lg={4}>
            Preis
          </Col>
          <Col lg={2}>
            Anzahl
          </Col>
          <Col lg={2} className={styles.ColumnRight}>
            Summe
          </Col>
        </Row>
        {desktopListItems}
      </div>
    </div>
  );
};

const QuantityCell = ({
  row,
  data: {
    onCounterChange,
    incCounterClicked,
    decCounterClicked,
    onCheckboxChange,
    selItems,
  },
}) => {
  return (
    <div className={styles.FlexCell}>
      <div className={styles.HeaderInline}>Anzahl</div>
      {row.productOrderType !== APP_CONST.PRODUCT_ORDER_TYPE_OPTION ? (
        <div className={styles.Counter}>
          <Counter
            disabled={
              row.mandatory || row.productType == 'fixed'
            }
            value={
              selItems != null && selItems[row.purchaseProductId] != null
                ? selItems[row.purchaseProductId].amount
                : row.count
            }
            incClicked={e =>
              incCounterClicked(e, row.purchaseProductId, row)
            }
            decClicked={e =>
              decCounterClicked(e, row.purchaseProductId, row)
            }
            onChange={e =>
              onCounterChange(e, row.purchaseProductId, row)
            }
          />
        </div>
      ) : (
        <div className={styles.Cell}>
          <input
            className={styles.Input}
            type="checkbox"
            checked={
              selItems != null && selItems[row.purchaseProductId] != null
                ? selItems[row.purchaseProductId].amount == 1
                : false
            }
            onChange={e =>
              onCheckboxChange(e, row.purchaseProductId, row)
            }
            name="counter"
          />
        </div>
      )}
    </div>
  );
};

Items.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  onDeleteItem: PropTypes.func,
  incCounterClicked: PropTypes.func,
  decCounterClicked: PropTypes.func,
  onCounterChange: PropTypes.func,
};
